import { useState, useEffect } from "react";
import { apiEndpoints } from "../../../utils/api";

/**
 * Hook to fetch and manage workspace data
 * @param {string} workspaceId - The workspace ID
 * @param {Object} authenticatedApi - The authenticated API client
 * @returns {Object} Object containing workspace data, loading state, and error
 */
export const useWorkspace = (workspaceId, authenticatedApi) => {
  const [workspace, setWorkspace] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!workspaceId || !authenticatedApi) {
      setLoading(false);
      return;
    }

    const fetchWorkspace = async () => {
      try {
        setLoading(true);
        setError(null);
        const workspaceData = await authenticatedApi.get(
          apiEndpoints.workspace(workspaceId),
        );
        setWorkspace(workspaceData);
      } catch (err) {
        console.error("Error fetching workspace:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchWorkspace();
  }, [workspaceId, authenticatedApi]);

  return {
    workspace,
    loading,
    error,
    isSandbox: workspace?.is_sandbox || false,
  };
};
